<section class="auth-action-shell">
  <div class="card">
    <p class="eyebrow">Compte</p>
    <h1>Validation de l’adresse email</h1>

    <p class="lead" *ngIf="loading">Validation du compte en cours…</p>
    <p class="success" *ngIf="successMessage">{{ successMessage }}</p>
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <p class="redirect-note" *ngIf="successMessage && isAndroidDevice">
      Si l’application est installée et liée au domaine, utilisez le bouton ci-dessous pour
      revenir dans AfriFood.
    </p>

    <div class="actions">
      <a *ngIf="successMessage" [href]="openAppUrl">Ouvrir l’application</a>
      <a [href]="playStoreUrl" target="_blank" rel="noopener">Télécharger l’application</a>
      <a routerLink="/">Retour à l’accueil</a>
    </div>
  </div>
</section>
